import { useEffect, useState } from "react";
import { CreditCard } from "lucide-react";
import { toast } from "sonner";
import { apiDelete, apiGet } from "@/lib/apiAdmin";
import { HUD } from "./theme";

export const SavedCards = ({ contactKey }) => {
  const [cards, setCards] = useState([]);
  const load = () => apiGet("/admin/saved-cards", { contact_key: contactKey }).then((d) => setCards(d.items)).catch(() => {});
  useEffect(() => { load(); }, [contactKey]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!cards.length) return null;
  const remove = (c) => window.confirm(`Remove ${c.brand} ••${c.last4} from file?`) &&
    apiDelete(`/admin/saved-cards/${c.card_id}`).then(() => { toast.success("Card removed"); load(); });
  return (
    <div className="space-y-1" data-testid={`jarvis-saved-cards-${contactKey}`}>
      <p className={HUD.label}>Cards on file (charge from any unpaid invoice → Edit)</p>
      {cards.map((c) => (
        <div key={c.card_id} className="flex items-center gap-2 rounded-lg border border-cyan-400/10 p-2" data-testid={`jarvis-saved-card-${c.card_id}`}>
          <CreditCard className="w-4 h-4 text-cyan-300" />
          <span className="flex-1">{c.brand} ••{c.last4}{c.exp ? ` · exp ${c.exp}` : ""} · {c.provider === "nmi" ? "Wholesale" : "Square"}</span>
          <button onClick={() => remove(c)} className="text-gray-500 hover:text-rose-300" data-testid={`jarvis-saved-card-remove-${c.card_id}`}>remove</button>
        </div>
      ))}
    </div>
  );
};
